// https://www.jacklmoore.com/autosize/
import autosize from "js/plugins/autosize.min.js"

$(document).on('turbolinks:load', function(event) {
    autosize($('textarea'));
});
